export const BOOKING_PROTOCOL = {
    title: '六六找房房客预订协议',
    abstraction: '作为房客，请您务必仔细阅读并透彻理解本规则的全部内容，因为它包含了关于您在六六找房预订房源以及房租等费用收取等重要内容，如您不同意本规则的任意内容，请立即停止使用六六找房预订服务，使用六六找房预订服务即被视为您对本规则全部内容的认可并依法受其约束。',
    protocols: [
        {
            clauses: [
                {
                    subtitle: '一、房源预订',
                    details: [
                        { text: '如您预订房源，您需在六六找房平台注册并登陆相应的账号。' },
                        { text: '预订房源前，您应仔细阅读房源信息，确保清楚了解房东描述的房源信息，如月租金、租房必读等，并接受房东制定的房屋使用规则、交易规则等相关约束条件。您可通过六六找房发起预订或确认并支付房东发起的预订，经房东确认和房客确认并完成支付的订单视为有效订单，订单生效后将自动生成房屋租赁合同。' },
                        { text: '您发起的预订，需要房东确认，提交预订后房东会在规定时间内处理您的订单：确认或取消您的预订请求。' },
                        { text: '作为房客，您清楚六六找房是信息服务平台。对于平台上房东自主发布的所有信息，当您发现疑似虚假或违法信息时，应立即向六六找房举报。六六找房将按照相应的平台规则采取必要措施。' },
                        { text: '您理解并同意，凡您对某个房源进行操作就表明您对本规则已经认真阅读，并且接受本规则项下的约束。如果您对本规则内任何条款不予认同，请您立即停止对六六找房平台内的房源进行任何操作。' },
                        { text: '未成年人应在监护人陪同下进行预订及入住。若未成年人自行预订房间的，在入住前需向房东提供《监护人声明》和证明亲子关系的《户口本》等材料，否则房东有权拒绝该未成年人入住。' }
                    ]
                },
                {
                    subtitle: '二、费用支付',
                    details: [
                        { text: '平台预定页面默认显示该房源一年起租的月租金，根据您选择的租期，系统将会展示该房源的实际月租金。' },
                        { text: '页面显示的预付款金额为房源的月租金或您与房东沟通后房东修改后的预付款金额，提交预订时，您需仔细核对预付款金额，并清楚了解付款规则。' },
                        { text: '房东发送给您预订订单或修改您发起的预定订单后，您应在规定时间内，通过六六找房在线成功支付全部预付款金额，逾期未成功支付，系统则默认此订单过期失效。' },
                        { text: '您与房东线下或自行达成的任何承诺或协议与六六找房无关，六六找房不对此承诺或协议作出任何解释或承担任何责任。' }
                    ]
                },
                {
                    subtitle: '三、取消预订及退款',
                    details: [
                        { text: '符合取消订单政策进行取消操作的，您可登录六六找房上的用户账号取消订单：在“订单”中执行“取消”预订操作。' },
                        { text: '若您在起租日前取消订单，按照平台交易规则，从预付款里扣除违约金，剩余部分（若有）原路退回，扣除的违约金将支付给房东作为您的违约赔偿款。具体的扣款金额以App上取消订单时显示的金额和规则为准。' },
                        { text: '若您在起租日后，不能按照房屋租赁合同的租期住满，需要提前退房，将按照您与房东签订的租房合同执行，扣除您押金作为违约金，剩余部分（如有）返还。' },
                        { text: '所有退款均按照付款途径原路返还。' },
                        { text: '发生下列情形之一时，六六找房将有权酌情扣您的预付款，或酌情延期处理您的预付款，并有权取消订单：', subjects: [
                            '根据《中华人民共和国反不正当竞争法》等相关法律法规的规定，您被发现存在疑似为获取房源及房东个人信息而进行的恶意下单和操作的行为。',
                            '根据《中国人民共和国宪法》、《中华人民共和国刑法》等相关法律法规的规定，您被房东或六六找房工作人员发现并举报在房源内即将进行或已经进行了不正当的或违法的行为。（该类行为包括但不限于聚众赌博、吸毒、倒卖走私商品、实施与淫秽色情有关的行为）。',
                            '您有其他涉嫌违反法律法规、或违背社会公共利益或公共道德、损害他人的合法权益、损害六六找房、房东权益行为或违反其他六六找房平台规则行为的。'
                        ] }
                    ]
                },
                {
                    subtitle: '四、入住须知',
                    details: [
                        { text: '入住过程中，请您自觉遵守《房客入住规则》，爱护屋内环境及设施，确保设施无损坏。否则，将由您与房东自行协商达成赔偿协议或按照房屋租赁合同约定的条款处理。' },
                        { text: '房屋使用过程中发生的任何意外情况、房东对房客在入住时的任何行为约束、线下交易行为等引起的任何性质的纠纷，应由您与房东自行通过法律途径解决，六六找房不负有任何性质的协助义务和承担任何形式的责任。' }
                    ]
                },
                {
                    subtitle: '五、其他',
                    details: [
                        { text: '六六找房有权在任何时间不时地制订、变更或修改本规则。一旦条款内容发生变更，“六六找房”将会在相关的页面进行公布，不再单独通知您。变更后的服务协议或规则公布7天后生效。如您不同意相关变更，请立即停止使用“六六找房”服务。如您继续使用六六找房服务，即表示您接受变更后的服务协议或规则。当发生有关争议时，以最新的服务协议或规则为准。' },
                        { text: '本规则于【2020】年【4】月【15】日发布，自发布之日起7日后生效。' }
                    ]
                }
            ]
        }
    ]
}